<div class="" id="top-page">
  <!-- <app-color-switcher *ngIf="isMultiColorActive"></app-color-switcher> -->
  <router-outlet></router-outlet>
</div>
<simple-notifications></simple-notifications>
